// lib/feature-flags.ts
//
// Compile-time feature flags for the public site. Toggle a value here
// and redeploy — no env var dance. Used for soft-launch / content-not-
// ready states where we want to ship the implementation without
// surfacing the page to visitors and search engines.

// When false:
//   - /courses, /courses/[slug], /courses/[slug]/register → 404
//   - /mentors, /mentors/[slug] → 404
//   - Navbar + footer omit the links
//   - sitemap.ts omits the URLs
// Flipped 2026-06-01: 3 published courses live with provider + bilingual
// content + cover images. SkipCash still in test mode — payment flow will
// be gated separately until production creds are in place.
export const COURSES_PUBLIC_ENABLED = true;

// Phase 3B client-facing messaging is gated by a RUNTIME setting in the
// dashboard at /settings/general (key: client_messaging_enabled in the
// app_settings table). Read it via isClientMessagingEnabled() from
// lib/app-settings.ts instead of a compile-time constant — that way admins
// can flip it without a redeploy when the student portal eventually goes
// live.

// Public CTF events listing (/ctf). When false the page 404s and is omitted
// from nav/sitemap. Independent of whether any event is actually public —
// that is decided per-event in the dashboard (visibility + self-registration).
export const CTF_PUBLIC_ENABLED = true;
